import { gql } from "@apollo/client";

const ACCEPT_INVOICE = gql`
  mutation acceptInvoice($userId: [ID!]!, $campaignId: ID!, $vat: String) {
    acceptInvoice(userId: $userId, campaignId: $campaignId, vat: $vat)
  }
`;

export default ACCEPT_INVOICE;
